import "../scss/main.scss";
import "./bootstrap.min.js";
import "./jquery.basictable.min.js";
import AOS from "./aos";
import "./owl.carousel.min.js";
import "./jquery.vide.min.js";
import TypeIt from "./typeit.min";
import "./Chart.min.js";
import "./chartjs-plugin-labels.min.js";
import "./jquery.bootstrap.wizard.min.js";
import "./prettify.js";
import html2pdf from "html2pdf.js";

jQuery.noConflict();
jQuery(function ($) {
    // For Pdf download at Summary page - if clikced as FS screen
    // jQuery("#pdf-download-button").on("click", function () {
    //     var element = document.getElementById("pdf-content-temp");
    //     console.log(element);
    //     var opt = {
    //         margin: 1,
    //         filename: "pslfjobs-summary.pdf",
    //         image: { type: "jpeg", quality: 1 },
    //         html2canvas: {
    //             dpi: 96,
    //             scale: 1,
    //             letterRendering: true,
    //             y: 0,
    //             scrollY: 0
    //         },
    //         jsPDF: { unit: "in", format: "ledger", orientation: "portrait" }
    //     };
    //     html2pdf().set(opt).from(element).save();
    // });

    $('[data-toggle="tooltip"]').tooltip();

    $(".gf_step").html(function (i, html) {
        return html.replace(/&nbsp;/g, "");
    });

    $(".targetDiv").hide();
    $("#c_tab1").show();
    $("#showall").on("click", function () {
        $(".targetDiv").show();
    });
    $(".showSingle").on("click", function () {
        $(".targetDiv").hide();
        $(".showSingle").removeClass("active");
        $(this).addClass("active");
        $("#c_tab" + $(this).attr("target")).show();
    });

    // Animation on scroll initilization
    AOS.init({
        easing: "ease-out-back",
        duration: 1000
    });
    var iconButton = $("#nav-icon3, .close-modal, .menu-btn");
    iconButton.on("click", function () {
        $(".menu-modal").removeClass("aos-animate");
        setTimeout(function () {
            $(".menu-modal").addClass("aos-animate");
        }, 400);
    });

    $("#nav-icon3, .close-modal, .menu-btn").on("click", function () {
        $(".menu-modal").toggle();
    });

    $(".ripple-btn").click(function (e) {
        // Remove any old one
        $(".ripple").remove();

        // Setup
        var posX = $(this).offset().left,
            posY = $(this).offset().top,
            buttonWidth = $(this).width(),
            buttonHeight = $(this).height();

        // Add the element
        $(this).prepend("<span class='ripple'></span>");

        // Make it round!
        if (buttonWidth >= buttonHeight) {
            buttonHeight = buttonWidth;
        } else {
            buttonWidth = buttonHeight;
        }

        // Get the center of the element
        var x = e.pageX - posX - buttonWidth / 2;
        var y = e.pageY - posY - buttonHeight / 2;

        // Add the ripples CSS and start the animation
        $(".ripple")
            .css({
                width: buttonWidth,
                height: buttonHeight,
                top: y + "px",
                left: x + "px"
            })
            .addClass("rippleEffect");
    });

    $(document).ready(function () {
        $("#rootwizard").bootstrapWizard({
            onTabShow: function (tab, navigation, index) {
                var $total = navigation.find("li").length;
                var $current = index + 1;
                var $percent = ($current / $total) * 100;
                $("#rootwizard .progress-bar").css({ width: $percent + "%" });
            }
        });

        // Hero Section of Home Page, - Type it dyanamic script
        if (
            jQuery("#homeHeroTagLinePart1").length ||
            jQuery("#homeHeroTagLinePart2").length ||
            jQuery("#homeHeroTagLinePart3").length ||
            jQuery("#homeHeroTagLinePart4").length
        ) {
            const tagLineFirst = jQuery("#homeHeroTagLinePart1").text();
            const tagLineSecond = jQuery("#homeHeroTagLinePart2").text();
            const tagLineThird = jQuery("#homeHeroTagLinePart3").text();
            const tagLineFourth = jQuery("#homeHeroTagLinePart4").text();

            jQuery(".type_content").empty();

            // console.log("tagLineFirst" + tagLineFirst);

            var typed = new TypeIt(".type_content", {
                speed: 50,
                waitUntilVisible: true,
                loop: true
            })
                .type(tagLineFirst + tagLineSecond, { delay: 300 })
                .pause(500)
                .delete(tagLineSecond.length)
                .type(
                    '<span class="highlight text-bold uppercase">' +
                        tagLineSecond +
                        "</span>"
                )
                .pause(500)
                .type(tagLineThird)
                .pause(500)
                .type("<u>" + tagLineFourth + "</u>")
                .pause(2000)
                .go();
        }

        $(window).scroll(function () {
            if ($(this).scrollTop() > 250) {
                $(".site_header").addClass("sticky");
            } else {
                $(".site_header").removeClass("sticky");
            }
        });

        // Media carousel
        $(".media-carousel").owlCarousel({
            //     onChange: callback,
            loop: true,
            dots: false,
            center: true,

            nav: true,
            navText: [
                "<i class='fa fa-chevron-left'></i>",
                "<i class='fa fa-chevron-right'></i>"
            ],

            responsive: {
                0: {
                    items: 1,
                    center: false
                },
                769: {
                    items: 1,
                    center: false
                },
                991: {
                    items: 3,
                    autoWidth: true
                }
            }
        });

        // On load added classes on media carousel
        jQuery(function ($) {
            $(".media-carousel")
                .find(".center.active")
                .prev()
                .addClass("listitem1");
            $(".media-carousel")
                .find(".center.active")
                .next()
                .addClass("listitem3");
        });

        // On change add and remove classes on media carousel
        $(".media-carousel .owl-nav button").on("click", function () {
            $(".owl-item").removeClass("listitem1").css("margin-left", "0px");
            $(".media-carousel")
                .find(".center.active")
                .prev()
                .addClass("listitem1")
                .css("margin-left", "98px");
            $(".owl-item").removeClass("listitem3");
            $(".media-carousel")
                .find(".center.active")
                .next()
                .addClass("listitem3");
        });

        // Logo carousel
        $(".logo-carousel").owlCarousel({
            loop: false,
            dots: false,
            nav: true,
            margin: 30,
            navText: [
                "<i class='fa fa-chevron-left'></i>",
                "<i class='fa fa-chevron-right'></i>"
            ],
            responsive: {
                0: {
                    items: 1
                },
                769: {
                    items: 1
                },
                992: {
                    items: 3
                }
            }
        });

        // Testimonial carousel
        $(".client-testimonial").owlCarousel({
            loop: true,
            dots: true,
            nav: true,
            margin: 30,
            autoplay: false,
            autoplayTimeout: 1000,
            autoplayHoverPause: true,
            navText: [
                "<i class='fa fa-chevron-left'></i>",
                "<i class='fa fa-chevron-right'></i>"
            ],
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 15,
                    margin: 15
                },
                769: {
                    items: 1,
                    stagePadding: 15,
                    margin: 15
                },
                992: {
                    items: 1,
                    stagePadding: 0,
                    margin: 30
                }
            }
        });

        // Scroll to top
        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                $(".scrollToTop").fadeIn();
            } else {
                $(".scrollToTop").fadeOut();
            }
        });

        $(".scrollToTop").on("click", function () {
            $("html, body").animate({ scrollTop: 0 }, 800);
            return false;
        });
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 1890) {
            $("#subscribe-modal").modal("show");
        }
    });

    $(".close").on("click", function () {
        $("#subscribe-modal").remove();
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open").css("padding", "0px");
    });

    // Toggle message on summary page
    $(".toggle-message-box").on("click", function () {
        $(".message-box-wrapper").css({
            visibility: "visible",
            height: "auto",
            "margin-top": "3rem"
        });
        $(".message-box-wrapper").animate(
            {
                height: "auto"
            },
            500
        );

        $("html, body").animate({
            scrollTop: $("#outcome_section").position().top
        });
    });

    $(".close-message").on("click", function () {
        $(".message-box-wrapper").slideUp();
    });

    // Responsive table
    $(".orange-table").basictable({
        breakpoint: 991
    });

    // Copy content of a div
    $(".copyModalContent").on("click", function () {
        copyUsingJquery("#copyTarget");
    });

    $("#copyModal .close").on("click", function () {
        $(".copyModalContent").html("Copy Text");
    });

    function copyUsingJquery(element_id) {
        $(element_id)
            .attr("contenteditable", true)
            .select()
            .on("focus", function () {
                document.execCommand("selectAll", false, null);
            })
            .focus();
        document.execCommand("Copy");
        $(element_id).removeAttr("contenteditable");
        $(".copyModalContent").html("Text Copied!");
    }

    $(".announcement-carousel").owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });
});
